// extracted by mini-css-extract-plugin
module.exports = {"submission-data":"submission-data__submission-data___328FH"};